/**
 * Build-time configuration assembled from Vite env vars.
 *
 * - VITE_GOOGLE_OAUTH_CLIENT_ID  — public; same value lives in the Worker too
 * - VITE_OAUTH_WORKER_BASE       — where the OAuth callback Worker lives
 *
 * Defaults below match the spike-default localhost layout so a fresh
 * `pnpm dev` works without env wiring.
 */

interface Config {
  googleOauthClientId: string;
  oauthWorkerBase: string;
  googleOauthRedirectUri: string;
  googleAdsProxyBase: string;
  metaAppId: string;
  metaOauthWorkerBase: string;
  metaOauthRedirectUri: string;
  licenseWorkerBase: string;
  hostnamesWorkerBase: string;
  cronWorkerBase: string;
}

const env = import.meta.env as unknown as {
  VITE_GOOGLE_OAUTH_CLIENT_ID?: string;
  VITE_OAUTH_WORKER_BASE?: string;
  VITE_GOOGLE_ADS_PROXY_BASE?: string;
  VITE_META_APP_ID?: string;
  VITE_META_OAUTH_WORKER_BASE?: string;
  VITE_LICENSE_WORKER_BASE?: string;
  VITE_HOSTNAMES_WORKER_BASE?: string;
  VITE_CRON_WORKER_BASE?: string;
};

const oauthWorkerBase = env.VITE_OAUTH_WORKER_BASE ?? "http://localhost:8787";
const googleAdsProxyBase =
  env.VITE_GOOGLE_ADS_PROXY_BASE ?? "http://localhost:8788";
const metaOauthWorkerBase =
  env.VITE_META_OAUTH_WORKER_BASE ?? "http://localhost:8789";
const licenseWorkerBase =
  env.VITE_LICENSE_WORKER_BASE ?? "http://localhost:8790";
const hostnamesWorkerBase =
  env.VITE_HOSTNAMES_WORKER_BASE ?? "http://localhost:8791";
const cronWorkerBase =
  env.VITE_CRON_WORKER_BASE ?? "http://localhost:8792";

export const config: Config = {
  googleOauthClientId: env.VITE_GOOGLE_OAUTH_CLIENT_ID ?? "",
  oauthWorkerBase,
  googleOauthRedirectUri: `${oauthWorkerBase}/oauth/callback/google`,
  googleAdsProxyBase,
  metaAppId: env.VITE_META_APP_ID ?? "",
  metaOauthWorkerBase,
  metaOauthRedirectUri: `${metaOauthWorkerBase}/oauth/callback/meta`,
  licenseWorkerBase,
  hostnamesWorkerBase,
  cronWorkerBase,
};

export function configCheck(): { ok: boolean; missing: string[] } {
  const missing: string[] = [];
  if (!config.googleOauthClientId) missing.push("VITE_GOOGLE_OAUTH_CLIENT_ID");
  if (!config.oauthWorkerBase) missing.push("VITE_OAUTH_WORKER_BASE");
  return { ok: missing.length === 0, missing };
}

export function metaConfigReady(): boolean {
  return Boolean(config.metaAppId) && Boolean(config.metaOauthWorkerBase);
}
